import { FAQs } from '../../../FAQs'
import { useEliteLandingPageScrollEvent } from '../../../../../hooks/useEliteLandingPageScrollEvent'
import { RebalancingTimerSection } from './RebalancingTimerSection'
import { RebalancingPlanSection } from './RebalancingPlanSection'
import { BrokeEliteBenefitsSection } from './broke/BrokeEliteBenefitsSection'
import { BrokeEliteMembershipCarousel } from './broke/BrokeEliteMembershipCarousel'
import { BrokePricing } from './broke/BrokePricing'
import { BrokeTrustedAdvisorySection } from './broke/BrokeTrustedAdvisorySection'
import VideoTrustMarker from '../../../VideoTrustMarker'
import CardsTrustMarker from '../../../CardsTrustMarker'
import type { EliteConsentTextItem } from '../../../../../types/misc.types'


export const BrokeEliteLandingPageBody = ({
    numberOfFundsToRebalance,
    missedGains,
    cta,
    timeToRebalancePlanDrop,
    isEliteButtonDisabled,
    isConsentChecked,
    isForceUpdateRequired,
    consentText,
    consentTextList,
    screenType,
    amount
}: {
    numberOfFundsToRebalance: number
    missedGains: number
    cta: Record<any, any> | null
    timeToRebalancePlanDrop?: number
    isEliteButtonDisabled: boolean
    isConsentChecked: boolean
    isForceUpdateRequired: boolean
    consentText?: string
    consentTextList?: EliteConsentTextItem[]
    screenType: string
    amount?: number
}) => {
    const withPowerUpEliteRef = useEliteLandingPageScrollEvent({ sectionName: 'With PowerUp Elite', screenType })
    const planRef = useEliteLandingPageScrollEvent({ sectionName: 'Plan', screenType })
    const faqRef = useEliteLandingPageScrollEvent({ sectionName: 'FAQ', screenType })

    return (
        <div className='flex flex-col bg-[#EBF2F2] gap-5 rounded-xl'>
            <RebalancingTimerSection
                timeToRebalancePlanDrop={timeToRebalancePlanDrop}
                cta={cta}
                isEliteButtonDisabled={isEliteButtonDisabled}
                isConsentChecked={isConsentChecked}
                isForceUpdateRequired={isForceUpdateRequired}
                consentText={consentText}
                consentTextList={consentTextList}
                screenType={screenType}
            />
            <RebalancingPlanSection
                numberOfFundsToRebalance={numberOfFundsToRebalance}
                missedGains={missedGains}
                cta={cta}
                isEliteButtonDisabled={isEliteButtonDisabled}
                isConsentChecked={isConsentChecked}
                isForceUpdateRequired={isForceUpdateRequired}
                consentText={consentText}
                consentTextList={consentTextList}
                screenType={screenType}
            />

            <BrokeEliteBenefitsSection sectionRef={withPowerUpEliteRef} screenType={screenType} />

            <div className='rounded-lg bg-white pt-5'>
                <BrokeEliteMembershipCarousel />
            </div>

            <div className='px-5 py-4'>
                <VideoTrustMarker />
            </div>
            <div className='px-5 pt-4 pb-6'>
                <CardsTrustMarker />
            </div>

            <div ref={planRef} className='rounded-lg bg-white pt-8 pb-12'>
                <div className='px-8'>
                    <BrokePricing screenType={screenType} amount={amount} />
                </div>
            </div>

            <div ref={faqRef} className='pb-7'>
                <FAQs />
            </div>

            <BrokeTrustedAdvisorySection />
        </div>
    )
}
